export default __webpack_public_path__ + "static/media/Fetish of Caged Fiends.e6e7ac1a.jpg";